import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-email-subscribe',
  templateUrl: './email-subscribe.component.html',
  styleUrls: ['./email-subscribe.component.scss']
})
export class EmailSubscribeComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<EmailSubscribeComponent>,
    @Inject(MAT_DIALOG_DATA) public modalData: any,
  ) 
  { }

  subscribe: any;

  closeModal() {
    this.dialogRef.close();
  }

  ngOnInit(): void {
    this.subscribe = this.modalData.subscribe
  }

}
